import React from 'react';
import { connect } from 'react-redux';
import TitleHashtag from './TitleHashtag';
import asyncComponent from '../../hoc/asyncComponent/asyncComponent';

// Style
import { st, classes } from './Hashtags.st.css';

const AsyncHashtagsGallery = asyncComponent(() => import('./hashtagsGallery'));

const Hashtags = ({
  isMobile,
  m_isDisplayHashtagsFeed,
  isDisplayHashtagsFeed,
  isBusinessApp,
}) => {
  if (!isBusinessApp) {
    return null;
  }

  const isDisplay = isMobile ? m_isDisplayHashtagsFeed : isDisplayHashtagsFeed;
  return (
    <div className={st(classes.root)}>
      <TitleHashtag />
      {isDisplay ? <AsyncHashtagsGallery /> : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  isMobile: state.appReducer.isMobile,
  isBusinessApp: state.appReducer.isBusinessApp,
  isConnected: state.appReducer.isConnected,
  isDisplayHashtagsFeed: state.settingsReducer.isDisplayHashtagsFeed,
  m_isDisplayHashtagsFeed: state.settingsReducer.m_isDisplayHashtagsFeed,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Hashtags);
